import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { FaSortDown } from 'react-icons/fa';
import { FaCaretRight } from 'react-icons/fa';
import { settingsPanelStyles as styles } from './styles';
import ReactTooltip from 'react-tooltip';

const link = require('../icons/link.svg');
const broken_link = require('../icons/broken_link.svg');

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

class PaddingEditor extends Component<IProps, any> {
    state = {
        isExpanded: false,
        isChecked: false,
    };

    updateAllPaddings(r) {
        this.props.descriptor.style.paddingTop = r;
        this.props.descriptor.style.paddingLeft = r;
        this.props.descriptor.style.paddingRight = r;
        this.props.descriptor.style.paddingBottom = r;
    }
    EquateAllPadding() {
        this.setState({ isChecked: !this.state.isChecked });
    }

    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div className={classes.panel}>
                    <span className={classes.header}>Padding</span>
                </div>

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            margin: 2,
                        }}>
                        <span className={classes.sub_header}>Top</span>

                        <input type="number" value={descriptor.style.paddingTop as number} onChange={(e) => (this.state.isChecked ? this.updateAllPaddings(+e.target.value) : (descriptor.style.paddingTop = +e.target.value))} className={classes.input + ' txtPaddingTop'} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            margin: 2,
                        }}>
                        <span className={classes.sub_header}>Bottom</span>

                        <input type="number" value={descriptor.style.paddingBottom as number} onChange={(e) => (this.state.isChecked ? this.updateAllPaddings(+e.target.value) : (descriptor.style.paddingBottom = +e.target.value))} className={classes.input} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            margin: 2,
                        }}>
                        <span className={classes.sub_header}>Left</span>
                        <input type="number" value={descriptor.style.paddingLeft as number} onChange={(e) => (this.state.isChecked ? this.updateAllPaddings(+e.target.value) : (descriptor.style.paddingLeft = +e.target.value))} className={classes.input} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            margin: 2,
                        }}>
                        <span className={classes.sub_header}>Right</span>
                        <input type="number" value={descriptor.style.paddingRight as number} onChange={(e) => (this.state.isChecked ? this.updateAllPaddings(+e.target.value) : (descriptor.style.paddingRight = +e.target.value))} className={classes.input} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            margin: 2,
                        }}>
                        <span className={classes.sub_header}>All</span>
                        <button data-for="link" title="Link Values" onClick={() => this.EquateAllPadding()}>
                            {this.state.isChecked ? <img src={link} /> : <img src={broken_link} />}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(PaddingEditor));
